// Geo IP from the browser; may fail under CORS (e.g. localhost) — returns "" then.
export default async function fetchDefaultCountry() {
  try {
    const res = await fetch("https://ipapi.co/json/");
    if (!res.ok) return "";
    const data = await res.json();
    return data.country_code_iso3 || "";
  } catch {
    return "";
  }
}
